// Article casque — désormais consommé via /magazine/:slug → MagazineArticlePage.
// Cette page fine reste pour la rétrocompatibilité SEO si jamais une URL
// historique existait. Elle réutilise le template générique avec les données
// du registre /data/magazine/casque.js et force le canonical sur le slug
// court SEO `/casque-moto-ece-22-06` pour consolider l'autorité.

import React from 'react';
import MagazineArticleTemplate from '../components/MagazineArticleTemplate';
import { casqueArticle } from '../data/magazine/casque';
import { findShortRouteBySlug } from '../data/seoShortRoutes';

export default function MagazineCasque() {
  const shortRoute = findShortRouteBySlug(casqueArticle.slug);
  return (
    <MagazineArticleTemplate
      article={casqueArticle}
      pathOverride={shortRoute?.path}
    />
  );
}
